// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../../apps/user-management/users-list/table/columns/UserCustomHeader'
import {listUserTimeKeeping} from '../models/timekeepingModels'
import {useIntl} from 'react-intl'
function useCustomIntl(messageId: string) {
  const intl = useIntl()
  return intl.formatMessage({id: messageId})
}
const UsersColumns: ReadonlyArray<Column<listUserTimeKeeping>> = [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={useCustomIntl('TABLE.INDEX')}
        className='min-w-30px text-center'
      />
    ),
    id: 'STT',
    Cell: ({...props}) => <div className='min-w-30px text-center ps-3'>{props.row.index + 1}</div>,
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={useCustomIntl('USER.CODE')}
        className='min-w-100px text-start pe-4'
      />
    ),
    id: 'member.code',
    Cell: ({...props}) => (
      <div className='min-w-30px text-start'>{props.data[props.row.index].memberCode}</div>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={useCustomIntl('USER.DISPLAYNAME')}
        className='min-w-150px text-start pe-4'
      />
    ),
    id: 'member.name',
    Cell: ({...props}) => (
      <div className='min-w-30px text-start'>{props.data[props.row.index].memberName}</div>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={useCustomIntl('USER.POSITION')}
        className='min-w-80px text-start pe-4'
      />
    ),
    id: 'member.position',
    Cell: ({...props}) => (
      <div className='min-w-30px text-start'>{props.data[props.row.index].position}</div>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={useCustomIntl('TIMEKEEPING.OFFICEHOURS')}
        className='min-w-80px text-center'
      />
    ),
    id: 'officeHour',
    Cell: ({...props}) => (
      <div className='min-w-30px text-center'>
        {parseFloat((props.data[props.row.index].totalOfficeHour / 8).toFixed(4))}
      </div>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={useCustomIntl('TIMEKEEPING.OVERTIME')}
        className='min-w-80px text-center pe-4'
      />
    ),
    id: 'overtimeHour',
    Cell: ({...props}) => (
      <div className='min-w-30px text-center'>
        {parseFloat((props.data[props.row.index].totalOvertimeHour / 8).toFixed(4))}
      </div>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={useCustomIntl('TIMEKEEPING.TOTALDAYOFF')}
        className='min-w-80px text-center pe-4'
      />
    ),
    id: 'totalDayOff',
    Cell: ({...props}) => (
      <div className='min-w-30px text-center'>{props.data[props.row.index].totalDayOff}</div>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={useCustomIntl('TIMEKEEPING.TOTALWORKINGDAY')}
        className='min-w-80px text-center pe-4'
      />
    ),
    id: 'totalWorking',
    Cell: ({...props}) => (
      <div className='min-w-30px text-center pe-3'>
        {parseFloat(
          (
            (props.data[props.row.index].totalOfficeHour +
            props.data[props.row.index].totalOvertimeHour) /
            8
          ).toFixed(4)
        )}
      </div>
    ),
  },
]

export {UsersColumns}
